module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "مصادر-القصة"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مصادر القصة")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كتاب الروضتين في أخبار الدولتين النورية والصلاحية، المؤلف: أبو القاسم شهاب الدين عبد الرحمن بن إسماعيل بن")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إبراهيم المقدسي الدمشقي المعروف بأبي شامة")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المتوفَّى")]), _vm._v(" 665 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هـ (المحقق: إبراهيم الزيبق، الناشر: مؤسسة الرسالة")]), _vm._v(" – "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بيروت، الطبعة الأولى،")]), _vm._v(" 1418 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هـ")]), _vm._v(" 1997 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("م، عدد الأجزاء: 5.")])]), _vm._v(" "), _c('p', [_vm._v("- "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كتاب البداية والنهاية، المؤلف: أبو الفداء إسماعيل بن عمر بن كثير القرشي البصري ثمَّ الدمشقي (المتوفّى: 774 هـ)، الناشر: دار الفكر، عام النشر")]), _vm._v("1407 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هـ 1986م، عدد الأجزاء: 15.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كتاب الدر الثمين في سيرة نور الدين - ابن قاضي شهبة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كتاب وفاء الوفاء بأخبار دار المصطفى، المؤلف: علي بن عبد الله بن أحمد الحسني الشافعي، نور الدين أبو الحسن السمهودي المتوفّى: 911ه، الناشر: دار الكتب العلمية")]), _vm._v(" - "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بيروت، الطبعة الأولى")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("1419ه،")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عدد الأجزاء: 4.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كتاب شذرات الذهب في أخبار مِن ذهب، المؤلف: عبد الحي بن أحمد بن محمد بن العماد العَكري الحنبلي، أبو الفلاح، (المتوفَّى: 1089ه)، حقَّقه: محمود الأرناؤوط، خرَّج أحاديثه: عبد القادر الأرناؤوط، الناشر: دار ابن كثير- دمشق")]), _vm._v(" – "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بيروت، الطبعة الأولى")]), _vm._v(" 1406 "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هـ 1986م، عدد الأجزاء: 11.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كتاب نزهة الناظرين في مسجد سيِّد الأوَّلين والآخِرين، لجعفر بن إسماعيل البرزنجي، الناشر: دار الكتب العلمية 01/01/1991.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47502448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch012.vue
// module id = 96
// module chunks = 0